var map = {
	"./assets/icons/360.svg": "Dwzj",
	"./assets/icons/arrow-down.svg": "/7LY",
	"./assets/icons/bigbang-icon.svg": "hEVc",
	"./assets/icons/bigbang-logo01.svg": "dYG7",
	"./assets/icons/bigbang-logo02.svg": "H0Ad",
	"./assets/icons/close.svg": "srjS",
	"./assets/icons/facebook.svg": "85DX",
	"./assets/icons/facebook_pink.svg": "HH8T",
	"./assets/icons/instagram.svg": "OCqi",
	"./assets/icons/instagram_pink.svg": "5Bov",
	"./assets/icons/twitter.svg": "lS6+",
	"./assets/icons/twitter_pink.svg": "AIlL",
	"./assets/images/BBang-Studios-Map.jpg": "vp4Z",
	"./assets/images/green-loader.svg": "8cbe",
	"./assets/images/loader.svg": "OTU4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ycmV";


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/assets.*$
// module id = ycmV
// module chunks = 1